import React, { Component } from 'react';
import Time from './layouts/Time.js';
import Click from './layouts/Click.js';
import '../App.css';

class Game extends Component {

constructor() {
	super();
	this.state = {};
}

ComponentDidMount() {

}

  render() {
    return (
      <div className="gameContainer">
        <Time nextStage={this.props.nextStage.bind(this)}/>
        <Click winner={this.props.winner.bind(this)} tie={this.props.tie}/>
      </div>
    );
  }
}

export default Game;



// WEBPACK FOOTER //
// ./src/components/Game.js